import { render, staticRenderFns } from "./crudBudget.vue?vue&type=template&id=5a5572f6&scoped=true&"
import script from "./crudBudget.vue?vue&type=script&lang=js&"
export * from "./crudBudget.vue?vue&type=script&lang=js&"
import style0 from "./crudBudget.vue?vue&type=style&index=0&lang=css&"
import style1 from "./crudBudget.vue?vue&type=style&index=1&id=5a5572f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5572f6",
  null
  
)

export default component.exports